import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Pending.css';

const Pending = ({ userData, day ,onSubmitrefresh}) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchPendingFeedbacks = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/adminfeedback`
        ,        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
);
        setFeedbacks(response.data.pendingFeedbacks);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch pending feedbacks');
        setFeedbacks([]);
      } finally {
        setLoading(false);
      }
    };

    if (userData?.id) {
      fetchPendingFeedbacks();
    }
  }, [day, userData]);

  const handleSubmitFeedback = (feedback) => {
    setSelectedFeedback({
      ...feedback,
      IdSchedule: feedback.Id, // Using pendingFeedbacks.Id for IdSchedule
      IdTeacher: userData.id, // Using userData.id for IdTeacher
      IdStudent: feedback.IdUser // Using IdStudent from the API response
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFeedback(null);
  };

  const handleSubmitSuccess = () => {
    // Refresh the feedback list after successful submission
    const fetchPendingFeedbacks = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/adminfeedback`
        ,        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
);
        setFeedbacks(response.data.pendingFeedbacks);
        onSubmitrefresh();
      } catch (err) {
        console.error('Error refreshing feedbacks:', err);
      }
    };
    fetchPendingFeedbacks();
  };

  const formatDate = (dateString) => {
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  if (loading) {
    return (
      <div className="pending-loading">
        <div className="spinner"></div>
        <p>Loading pending feedbacks...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pending-error">
        <p>Error: {error}</p>
        <button onClick={() => window.location.reload()}>Try Again</button>
      </div>
    );
  }

  if (feedbacks.length === 0) {
    return (
      <div className="pending-empty">
        <p>No pending feedbacks found</p>
      </div>
    );
  }

  return (
    <div className="pending-container">
      <h2 className="pending-title">Pending Feedbacks</h2>
      
      <div className="pending-feedbacks-list">
        {feedbacks.map((feedback, index) => (
          <div key={index} className="feedback-card">
            <div className="feedback-student-info">
              <img 
                src={feedback.Image} 
                alt={`${feedback.FirstName} ${feedback.LastName}`}
                className="student-avatar"
              />
              <div className="student-details">
                <h3>{feedback.FirstName} {feedback.LastName}{" "}{ (
                    <a 
                      href={`studentprofile/${feedback.IdUser}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="student-profile-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <svg 
                        viewBox="0 0 24 24" 
                        width="18" 
                        height="18" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </a>
                  )}</h3>
                  <p>Teacher: {feedback.TFirstName} {feedback.TLastName}</p>
                  
                <div className="class-info">
                  <span className={`class-badge ${feedback.Type === 0 ? 'paid' : 'demo'}`}>
                    {feedback.Type === 0 ? 'Paid' : 'Demo'}
                  </span>
                  <div className="datetime-info">
                    <span className="date">{formatDate(feedback.ClassDateTime)}</span>
                    <span className="time">{formatTime(feedback.ClassDateTime)}</span>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        ))}
      </div>

     
    </div>
  );
};

export default Pending;